import React, { useState } from 'react';
import './FreeTrialModal.css';

const FreeTrialModal = ({ onClose }) => {
  const [copied, setCopied] = useState(false);
  const contactEmail = 'rishi@egurukulapps.com';

  const mailtoUrl = `mailto:${contactEmail}?subject=Request%20for%20EgurukulApps%20Free%20Trial&body=Hi%20Rishi,%0D%0A%0D%0AI%20would%20like%20to%20request%20a%20free%20trial%20of%20EgurukulApps%20for%20our%20institution.%0D%0A%0D%0AInstitution%20Name:%20%0D%0AContact%20Person:%20%0D%0APhone%20Number:%20%0D%0ACity%20/%20Location:%20%0D%0AApprox.%20Number%20of%20Students:%20%0D%0A%0D%0APlease%20let%20us%20know%20the%20next%20steps.%0D%0A%0D%0AThank%20you!`;

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(contactEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="ftm-overlay" onClick={onClose}>
      <div className="ftm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="ftm-header">
          <div className="ftm-header-badge">🚀 Free Trial & Onboarding</div>
          <button className="ftm-close" onClick={onClose} aria-label="Close modal">
            ✕
          </button>
        </div>

        <div className="ftm-body">
          <h2 className="ftm-title">Get Started with EgurukulApps</h2>
          
          <p className="ftm-intro">
            Experience the complete, all-in-one Educational ERP suite for your school, tuition center, or coaching institute.
            To set up your customized institution workspace and enable all modules tailored to your requirements, please connect with our onboarding team.
          </p>

          {/* Contact Highlight Box */}
          <div className="ftm-contact-card">
            <div className="ftm-contact-icon-wrapper">
              <span className="ftm-contact-icon">✉️</span>
            </div>
            <div className="ftm-contact-details">
              <span className="ftm-contact-label">Direct Onboarding Contact</span>
              <a href={mailtoUrl} className="ftm-contact-email">
                {contactEmail}
              </a>
              <span className="ftm-contact-person">Contact Person: <strong>Rishi</strong> (EgurukulApps Lead)</span>
            </div>
            <button
              type="button"
              className={`ftm-copy-btn ${copied ? 'copied' : ''}`}
              onClick={handleCopyEmail}
            >
              {copied ? '✓ Copied' : '📋 Copy'}
            </button>
          </div>

          {/* Benefits Grid */}
          <div className="ftm-benefits-section">
            <h4 className="ftm-benefits-heading">What's included in your trial:</h4>
            <div className="ftm-benefits-grid">
              <div className="ftm-benefit-item">
                <span className="ftm-benefit-bullet">✓</span>
                <div>
                  <strong>Full ERP Access:</strong> Student profiles, attendance, fees, courses, and faculty management.
                </div>
              </div>
              <div className="ftm-benefit-item">
                <span className="ftm-benefit-bullet">✓</span>
                <div>
                  <strong>Mobile & Web Apps:</strong> Real-time access for administrators, teachers, parents, and students.
                </div>
              </div>
              <div className="ftm-benefit-item">
                <span className="ftm-benefit-bullet">✓</span>
                <div>
                  <strong>Personalized Setup:</strong> We help configure your classes, terms, fee structures, and branding.
                </div>
              </div>
              <div className="ftm-benefit-item">
                <span className="ftm-benefit-bullet">✓</span>
                <div>
                  <strong>Dedicated Support:</strong> 1-on-1 walkthrough and priority onboarding assistance.
                </div>
              </div>
            </div>
          </div>

          {/* Response time note */}
          <div className="ftm-response-note">
            ⏱️ <span>Our team usually sets up workspaces and responds within a few hours.</span>
          </div>

          {/* Action Buttons */}
          <div className="ftm-actions">
            <a href={mailtoUrl} className="ftm-primary-action">
              <span>📧 Send Email to {contactEmail}</span>
            </a>
            <button type="button" className="ftm-secondary-action" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeTrialModal;
